<template>
  <!-- eslint-disable vue/no-v-html -->
  <div>
    <TypedText v-if="shouldMessageBeAnimated" class="message" :text="sanitizedText" :interval="5" :steps="1" />
    <div v-else class="message" v-html="sanitizedText" />

    <message-sender :message="message" />
    <div
      v-if="buttonsVisible"
      :class="buttonsWrapperClasses"
    >
      <chatchamp-button
        v-for="button in buttons"
        :key="button.title"
        :button="button"
        :message="message"
        :emphasize="true"
      />
    </div>
  </div>
  <!-- eslint-enable -->
</template>

<script>
// @flow

import { mapGetters, mapState } from 'vuex'

import { linkify, sanitizedMarkup } from '../../../../common/utils'

import ChatchampButton from '../../ChatchampButton/ChatchampButton.vue'
import MessageSender from '../../MessageSender/MessageSender.vue'
import TypedText, { STOP_DELIMITER } from '../../TypedText/TypedText.vue'

export default {
  components: {
    ChatchampButton,
    MessageSender,
    TypedText
  },
  props: {
    message: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState(['customerId']),
    ...mapGetters(['primaryColor']),
    ...mapGetters(['primaryColor', 'latestMessage', 'isShowingOpenChat']),
    sanitizedText () {
      let text = this.message.content.text
      if (!this.shouldMessageBeAnimated && text.endsWith(STOP_DELIMITER)) {
        text = text.slice(0, -STOP_DELIMITER.length)
      }
      return linkify(sanitizedMarkup(text, this.message.content.messageId), this.message.content.messageId)
    },
    shouldMessageBeAnimated () {
      return this.isLatestMessage && this.isStreamMessage
    },
    buttonsWrapperClasses () {
      return {
        'buttons-wrapper': true,
        'buttons-wrapper--spacing': true
      }
    },
    buttons () {
      return this.message.content?.quick_replies || []
    },
    buttonsVisible () {
      return this.buttons.length && this.isLatestMessage
    },
    exitButton () {
      return this.message.content?.quick_replies?.find(button => button.type === 'exit')
    },
    exitButtonEnabled (): boolean {
      return this.buttons.length && this.isLatestMessage
    },
    isLatestMessage (): boolean {
      return this.latestMessage && this.message.id === this.latestMessage.id
    },
    isStreamMessage (): boolean {
      return this.message.streaming === true
    }
  }
}
</script>

<style src="./user-input-message.scss" />
